import React from 'react';
import {EstadoLlaveAnual} from 'src/views/dashboard/bussines/entities/EstadisticasLlave.entity';
import {dataPieChar} from '../types/pieChart.types';
import {meses} from '../consts/meses';

type fnMapperEstadoLlavesToDataPieChar = (params: {data: EstadoLlaveAnual[]}) => dataPieChar[];

export const mapperEstadoLlavesToDataPieChar: fnMapperEstadoLlavesToDataPieChar = ({data}) => {
   const mesesAgrupados: dataPieChar[] = data.reduce((result, {mes, estado, value}) => {
      if (mes !== 0) {
         const subData = result.find(item => item.mes === mes)?.subData;
         if (subData) {
            subData.push({
               etiqueta: estado,
               value
            });
         } else {
            result.push({
               mes: mes,
               denominacion: meses[mes - 1].labelLong,
               mark: meses[mes - 1].label,
               subData: [
                  {
                     etiqueta: estado,
                     value
                  }
               ]
            });
         }
      }
      return result;
   }, [] as dataPieChar[]);

   return mesesAgrupados;
};
